import styled from "styled-components";

export const Container = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb; /* light gray */
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);

  display: flex;
  flex-direction: column;
  gap: 12px;
`;
